
import { LockDec, ValidateDec } from "@/decorators";
import { TSX, Component, Prop, Vue } from 'vue-facing-decorator'

interface Props {
  item: any
}

@Component({})
export default class extends TSX<Props>()(Vue) implements Props {
  /** 商品列表行 */
  @Prop({})
  item: any;

  submitLoading = false;

  formData = {
    name: '',
  }

  created() {
    this.formData.name = this.item?.name || '';
  }

  /** 规则和后端 GoodsBaseOperatDto 对齐：2-20 个字符 */
  validateName(v) {
    if (!v) throw '请输入商品名称';
    let length = String(v).length;
    if (length < 2 || length > 20) throw '商品名称必须2-20个字符';
  }

  @ValidateDec("form")
  @LockDec("submitLoading")
  async submit() {
    /** 只发 name：base-operat 是「传了哪个改哪个」，不带 unit 就不会动单位 */
    await this.$postNotify("/manager/goods/base-operat", {
      id: this.item.id,
      name: this.formData.name,
    })
    this.$emit("resolve")
  }

  close() {
    this.$emit("reject", { msg: '取消' })
  }
}
